import { Button, H1 } from '@dnb/eufemia';
import { useMemo } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';

import BackButton from '@/components/BackButton';
import DataTable, { Column } from '@/components/DataTable';
import { useBackend } from '@/hooks/useBackend';
import { ServiceDomainResponse } from '@/openapi/schema';
import { humanDate } from '@/utils';

const COLUMNS: Column<ServiceDomainResponse>[] = [
  { header: 'Service Domain Id', attribute: 'serviceDomainId' },
  { header: 'Name', attribute: 'name' },
  {
    header: 'Created',
    attribute: 'createdAt',
    render: ({ createdAt }) => humanDate(createdAt),
  },
  {
    header: 'Updated',
    attribute: 'updatedAt',
    render: ({ updatedAt }) => humanDate(updatedAt),
  },
];

export function ServiceDomainPage() {
  const { data: serviceDomains, isLoading } = useBackend('/service-now/service-domains');
  const navigate = useNavigate();

  const barContent = useMemo(
    () => (
      <Button element={RouterLink} icon="add" icon_position="left" right="small" to="new" variant="secondary">
        Add Service Domain
      </Button>
    ),
    [],
  );

  return (
    <div>
      <BackButton to="/">Home</BackButton>
      <H1 top="large">Service Domains</H1>
      <DataTable
        barContent={barContent}
        columns={COLUMNS}
        data={serviceDomains ?? []}
        defaultSortKey="name"
        filterBy={['id', 'serviceDomainId', 'name']}
        onEdit={({ serviceDomainId }) => navigate(serviceDomainId)}
        skeleton={isLoading}
      />
    </div>
  );
}
